/**
 * The location picker on the reorder table (MOT-396). A member scoped to
 * locations has no whole-store view: the API answers their first location
 * when none is named, so "All locations" is never offered to them, whatever
 * is currently picked. `locationScoped` comes from the route; an older
 * response without it falls back to "a location came back although none was
 * asked for".
 */
export interface ReorderLocationPickerInput {
  locationScoped?: boolean;
  location?: { locationId: string } | null;
  locations?: Array<{ id: string }>;
}

export interface ReorderLocationPicker {
  scoped: boolean;
  /** Offer the "All locations" (whole store) option. */
  showAll: boolean;
  value: string;
  show: boolean;
}

export function reorderLocationPicker(data: ReorderLocationPickerInput | null | undefined, locationId: string): ReorderLocationPicker {
  const locations = data?.locations ?? [];
  const scoped = data?.locationScoped ?? (!locationId && !!data?.location);
  const value = locationId || (scoped ? data?.location?.locationId ?? '' : '');
  return {
    scoped,
    showAll: !scoped,
    value,
    show: locations.length > 1 || (scoped && locations.length > 0),
  };
}
